module.exports = __webpack_public_path__ + "static/media/upload.5c76a8cd.svg";